<div class="loading-indicator" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
<form #formRef [action]="fisPayment?.fisGatewayPostUrl" method="POST">
  <input type="hidden" name="Xml" [value]="fisPayment?.fisGatewayXml" />
  <input type="hidden" name="MerchantCode" [value]="fisPayment?.fisGatewayMerchantCode" />
  <!-- <button class="favorite styled" type="button">Ok</button> -->
</form>

<div class="m-3">
    <h1> Workers' Compensation Exemption Registration</h1>
  </div>

<div style="margin-top: 50px;">
  <div >
    <div class="row ">
      <div class="col-6">

        <div class="row">
          <div class="col-3" ></div>
          <div class="col-2" >Name</div>
          <div class="col-7" style="font-weight: bold;">{{name}}</div>
        </div>
      </div>

      <div class="col-6">
        <div class="row">

          <div class="col-10">
            <div class="row"  style="font-weight: bold;">{{downloadType}}
            </div>
          </div>
          <div class="col-2"  style="font-weight: bold;">${{amount}}
          </div>
        </div>
        <div class="row"><hr></div>
        <div class="row">
          *A service fee will be applied when paying via Credit/Debit Card or e-Check.
        </div>
        <div fxLayoutAlign="end" class="mt-3"><button [disabled]="isLoading" mat-raised-button (click)="formRef.submit()" color="primary">Make
            Payment</button></div>

      </div>
    </div>
    <div class="row">
      <!-- <button class="grey-button" mat-raised-button style="margin-left: 27px;margin-top: 50px;max-width: 120px;" (click)="onBack()">Back</button> -->
    </div>
  </div>
</div>
